"use strict";

/**
 * @function
 * @description function to set the clear position button depending on the input field errors height
 * @param {string} elem - the input field for which the clear button position is calculated
 */
const setClearButtonPosition = elem => {
    const $inputField = $(elem);
    const $parent = $inputField.closest(".form-group");
    const $clearButton = $parent.find(".clear-input-button");

    if ($clearButton.length) {
        const $inputError = $parent.find(".invalid-feedback");
        const elementBottomDistance = 12;
        const $fieldRequirements = $parent.find(".js-input-message-requirement");

        if ($fieldRequirements.length && $fieldRequirements.css("display") == "block") {
            $clearButton.css("bottom", elementBottomDistance + $inputError.outerHeight() + $fieldRequirements.outerHeight() + "px");
        } else {
            $clearButton.css("bottom", elementBottomDistance + $inputError.outerHeight() + "px");
        }
    }
};

module.exports = setClearButtonPosition;
